import { render, staticRenderFns } from "./Warmwasser.vue?vue&type=template&id=2a73fe9e&"
import script from "./Warmwasser.vue?vue&type=script&lang=js&"
export * from "./Warmwasser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports